module.exports = function getResource(label, vars = []) {
    let resources = {
        newText: 'NEW'
    };
    return resources[label];
};
